const stripHtml = function(content: string) {
  let domParser, strippedContent
  if (typeof window !== 'undefined') {
    domParser = new DOMParser()
    strippedContent = domParser.parseFromString(content, 'text/html').body.textContent
  } else {
    // @ts-ignore
    const striptags = require('striptags')
    strippedContent = striptags(content)
  }
  return strippedContent
}

export default {
  stripHtml: stripHtml
}
